import {Base} from "./base";
import {tokenCache} from "../lib/cache";

class UserService extends Base {
  constructor() {
    super();
  }

  /**
   * 获得用户信息
   * @returns {Promise<*>}
   */
  async get() {
    const {code, obj, msg} = await this.$http('nethos.pat.info.get', {}, {}, {showError: false});
    if (code === '0') return obj;
    //bus.$emit('msg', msg);
    return {code, msg};
  }

  /**
   * 修改资料
   * @param patId
   * @param maritalStatus
   * @returns {Promise<boolean>}
   */
  async modify({patId, maritalStatus}) {
    const {code} = await this.$http('nethos.pat.info.modify', {patId, maritalStatus})
    return code === '0';
  }

  /**
   * 退出登录
   * @returns {Promise<boolean>}
   */
  async logout(openid) {
    const {code} = await this.$http('nethos.pat.wechat.logout', {
      openid
    });
    return code === '0';
  }

  /**
   * 常用就诊人列表
   * @returns {Promise<[]>}
   */
  async compatList() {
    const {list = []} = await this.$http('nethos.pat.compat.list', {
      // clientStr: 999
    });
    return list;
  }

  /**
   * 设置默认就诊人
   * @param options.compatId
   * @returns {Promise<T>}
   */
  async setSelfCompat(options) {
    return await this.$http('nethos.pat.compat.selfcompat', options);
  }

  /**
   * 判断是否有就诊人，是否有默认就诊人
   */
  async compatJudge(){
    return await this.$http('nethos.pat.compat.compatJudge',{});
  }
}

export const userService = new UserService();



// WEBPACK FOOTER //
// ./src/services/user.js